// From https://stackoverflow.com/questions/40099093/capitalize-names-in-javascript
export default function(name, lower = false) {
  return (lower ? name.toLowerCase() : name).replace(
    // eslint-disable-next-line no-control-regex
    /(?:^|\s|['`‘’.-])[^\x00-\x60^\x7B-\xDF](?!(\s|$))/g,
    function(a) {
      return a.toUpperCase();
    }
  );
}
